module.exports = __webpack_public_path__ + "static/img/mg.5c85f139.jpg";